export default __webpack_public_path__ + "static/media/0.6mm 2.d222616a.jpg";